<template>
    <hts-drawer
        v-model="visible"
        :title="$t('labels.sellingPriceAdd')"
        size="large"
        :rules="CRules"
        :submit="handleSubmit"
        @close="closeOverSide">
        <div :style="{ minWidth: minWidthScroll }">
            <hts-card :title="$t('labels.fleetVehicle')">
                <div class="grid gap-x-2 grid-cols-3">
                    <!--
                      <hts-select-cooperator
                      v-model="dataAdd.vendor"
                      v-model:name="dataAdd.vendorName"
                      :label="$t('labels.nameFleetVehicle')"
                      class="col-span-2"
                      type-cooperator="PARTNER"
                      :creatable="true"
                      required
                      prop="vendor"
                      name-select="fleetVehicle"
                      @change="(val) => vendorChange(val)" />
                    -->

                    <hts-select-cooperator-contact
                        v-model="dataAdd.contact"
                        v-model:name="dataAdd.contactName"
                        :cooperator-id="cooperaterId"
                        :label="$t('labels.vendorPriceModule.contact')"
                        required
                        prop="contact"
                        name-select="contact"
                        @change="(contact) => selectContact(contact)" />
                    <hts-form-input
                        v-model="dataAdd.phone"
                        :label="$t('labels.phone')"
                        disabled />
                    <hts-form-input
                        v-model="dataAdd.email"
                        :label="$t('labels.email')"
                        disabled />
                </div>
            </hts-card>

            <hts-card :title="$t('labels.generalInformation')">
                <div class="w-full">
                    <hts-select-work-flow
                        v-model="dataAdd.workflow"
                        v-model:name="dataAdd.workflowName"
                        prop="workflow"
                        :disabled="disabled"
                        @change="selectWorkflow" />
                    <hts-workflow-position
                        :positions="dataAdd.positions"
                        :same-positions="dataAdd.theSamePositions"
                        :is-active="true">
                        <template #default="{ item, index }">
                            <span>
                                {{ item.nodeTypeName }}
                            </span>
                            <hts-form-select
                                v-model="dataAdd.positions[index].quoteEqual"
                                required
                                class="mr-2"
                                :label="$t('labels.quoteEqual')"
                                :items="listSelectQuoteEqual"
                                :prop="'quoteEquals' + index"
                                @change="handleChangeSelectedQuoteEqual(index)" />
                        </template>
                    </hts-workflow-position>
                    <div
                        v-if="dataAdd.positions.length > 0"
                        v-loading="loadingSelectNode">
                        <span class="text-base block px-0 font-medium text-default-500">
                            {{ $t('labels.route') }}
                        </span>
                        <div
                            v-for="(item, index) in dataAdd.positions"
                            :key="index"
                            class="pl-10">
                            <hts-select-node
                                v-model="dataAdd.positions[index].node"
                                v-model:name="dataAdd.positions[index].fullNameNode"
                                :node-type-id="item.nodeType"
                                :prop="item.nodeType + index"
                                :label="item.nodeTypeName"
                                :key-label="getKeyLabel(item.quoteEqual)"
                                :businesses="item.businesses"
                                :location-type="item.quoteEqual"
                                :key-sub-label="getKeySubLabel(item.quoteEqual)"
                                :disabled="disabled"
                                required
                                :param-prepare="`${dataAdd.positions[index].quoteEqual}-${dataAdd.positions[index].nodeType}`"
                                @change="(val) => handelChangeSelectNode(index, val)" />
                        </div>
                        <div v-if="dataAdd.transportation">
                            <div v-if="dataAdd.transportation === 'CONTAINER'">
                                <hts-form-select
                                    v-model="dataAdd.contCategory"
                                    :label="$t('labels.containerType')"
                                    :clearable="true"
                                    :required="true"
                                    :items="dataSelectWorkFlowData"
                                    key-id="value"
                                    key-label="label"
                                    prop="workflowData"
                                    name="workflowData"
                                    :color="props.color"
                                    :disabled="disabled"
                                    @change="changeCategoryShipping" />
                                <div class="flex">
                                    <hts-form-checkbox
                                        v-if="dataAdd.contCategory === 20"
                                        v-model="dataAdd.mergeContainer"
                                        color="secondary"
                                        :disabled="disabled"
                                        :items="[{ label: $t('labels.mergeContainer'), value: false }]" />
                                    <hts-form-checkbox
                                        v-model="dataAdd.headContainer"
                                        color="secondary"
                                        :disabled="disabled"
                                        :items="[{ label: $t('labels.headContainer'), value: false }]" />
                                </div>
                            </div>
                            <div v-else>
                                <hts-select-category-vehicle
                                    v-model="dataAdd.vehicleCategory"
                                    v-model:name="dataAdd.vehicleCategoryName"
                                    required
                                    prop="workflowData"
                                    :disabled="disabled"
                                    @change="changeCategoryShipping" />
                            </div>
                        </div>
                        <div class="block mt-5">
                            <div class="inline-block align-middle">
                                <span>
                                    {{ $t('labels.maxTaskCompletionTime') }}
                                </span>
                                <span class="text-error-500">
                                    *
                                </span>
                            </div>

                            <div
                                class="tooltip inline-block align-middle"
                                :data-tip="$t('labels.warningTaskQuoteRequest')">
                                <hi-information-circle-icon class="flex items-center text-green-500 w-6 h-6" />
                            </div>
                        </div>
                        <div class="block mb-5 ml-8">
                            <div
                                v-for="(item, index) in dataAdd.tasks"
                                :key="index"
                                class="grid grid-cols-2 gap-4">
                                <hts-form-select
                                    v-model="dataAdd.tasks[index].code"
                                    required
                                    :items="taskItems"
                                    key-id="code"
                                    key-label="taskName"
                                    key-sub-label="businessName"
                                    key-disabled="disabled"
                                    name="task"
                                    :prop="'task' + index"
                                    @change="(val) => handleChangeSelectedTask(val, index)" />
                                <div class="flex justify-center items-center">
                                    <hts-form-input
                                        v-model="dataAdd.tasks[index].value"
                                        type="number"
                                        name="completionTime"
                                        class="flex-1"
                                        :prop="'time' + index">
                                        <template #suffix>
                                            <span class="capitalize">
                                                {{ $t('labels.hour') }}
                                            </span>
                                        </template>
                                    </hts-form-input>
                                    <hi-x-circle-icon
                                        v-if="dataAdd.tasks.length > 1"
                                        class="h-6 w-6 mb-3 ml-2 text-error-600 cursor-pointer"
                                        @click="deleteTask(index)" />
                                </div>
                            </div>
                            <div class="flex mt-2 text-main-600">
                                <div
                                    class="flex cursor-pointer"
                                    @click="addTask">
                                    <hi-plus-circle-icon class="h-5 w-5" />
                                    <span>
                                        {{ $t('labels.add1') }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="grid gap-x-2 grid-cols-2">
                        <hts-form-date
                            v-model="dataAdd.effectiveFromDate"
                            :label="$t('labels.vendorPriceModule.effectiveFromDate')"
                            type="date"
                            required
                            prop="vendorPriceModule.effectiveFromDate"
                            name="vendorPriceModule.effectiveFromDate" />
                        <hts-form-date
                            v-model="dataAdd.effectiveToDate"
                            :label="$t('labels.effectiveToDateDescription')"
                            type="date"
                            prop="vendorPriceModule.effectiveToDate"
                            name="vendorPriceModule.effectiveToDate" />
                        <hts-form-select
                            v-model="dataAdd.typeCommodity"
                            :label="$t('labels.goodsTypes')"
                            required
                            :items="cTypeCommodity || []"
                            multiple
                            :disabled="disabled"
                            select-all-disabled
                            key-id="key"
                            key-label="title"
                            :color="color"
                            name="goodsTypes"
                            prop="commodityType" />
                        <hts-form-input
                            v-model="dataAdd.weightCommodity"
                            :label="$t('labels.weightCommodityByKGMaximum')"
                            type="number"
                            required
                            prop="weightCommodityByKGMaximum"
                            name="weightCommodityByKGMaximum">
                            <template #suffix>
                                <span>
                                    {{ dataAdd.transportation ? (dataAdd.transportation === 'CONTAINER' ? $t('labels.cont') : $t('labels.vehicle')) : '-' }}
                                </span>
                            </template>
                        </hts-form-input>
                    </div>
                    <div>
                        <hts-form-textarea
                            v-model="dataAdd.description"
                            :label="$t('labels.description')" />
                    </div>
                </div>
            </hts-card>
            <hts-card :title="$t('labels.priceInfo')">
                <div class="grid gap-x-2 grid-cols-2">
                    <hts-form-input
                        v-model="dataAdd.price"
                        label="Giá bán"
                        required
                        type="number" />
                    <hts-form-input
                        v-model="dataAdd.oilPrice"
                        :label="$t('labels.oilPriceNotVat')"
                        type="number" />
                </div>
            </hts-card>
        </div>
    </hts-drawer>
</template>

<script lang="ts" setup>
import { computed, ref, shallowRef } from 'vue'
import { IVendorPrice, getTypeCommodity } from './data'
import { ruleAddVendorPrices } from './form'
// import MapPosition from '~/components/map/position.vue'
import { $api, $lodash, useRoute } from '#imports'

import screen from '~/components/utils/screen'
const { map: mapStore } = $store()

const breakpoint = screen()
const minWidthScroll = computed(() => {
  return `${breakpoint.value.thresholds.sm + 100}px`
})

const { $disableReactive } = useNuxtApp()
const store = $store()

const cooperaterId = computed(() => store.system.company.cooperator)

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 2
  }
})

const emits = defineEmits(['refreshTables'])
const initData = {
  createPriceFrom: 3,
  quote: null,
  quoteCode: null,
  quoteRequest: null,
  quoteRequestCode: null,
  vendor: null,
  vendorName: '',
  contact: null,
  contactName: '',
  email: null,
  phone: null,
  workflow: null,
  workflowName: '',
  transportation: '',
  contCategory: null,
  vehicleCategory: '',
  effectiveFromDate: null,
  effectiveToDate: null,
  price: null,
  oilPrice: null,
  description: null,
  positions: [],
  theSamePositions: [],
  typeCommodity: ['NORMAL'],
  mergeContainer: false,
  headContainer: false,
  weightCommodity: null,
  tasks: [
    {
      code: '',
      value: ''
    }
  ],
  priceOfflineFee: []
}

const visible = ref(false)

const minWeightCommodity = ref(-1)

const passCreateFromChange = ref(false)
const route = useRoute()

const open = async () => {
  mapStore.setShowLocation({ priceVendor: false })

  await getLastGasoline()
  visible.value = true
}

const getData = async (id: string, createBy: string) => {
  if (createBy === 'quote') {
    dataAdd.value.createPriceFrom = 1
    const api = $url.quote.detail
    const data: any = await $api(api, { uriParams: { ID: id } })
    const resData: any = data.data.value
    if (resData?.success) {
      dataAdd.value.quote = resData.data._id
      dataAdd.value.quoteCode = resData.data.code
      quoteChange([resData.data])
    }
  }
  if (createBy === 'quote-request') {
    dataAdd.value.createPriceFrom = 2
    const api = $url.quote.quoteRequest.getDetail
    const data: any = await $api(api, { uriParams: { ID: id } })
    const resData: any = data.data.value
    if (resData?.success) {
      dataAdd.value.quoteRequest = resData.data._id
      dataAdd.value.quoteRequestCode = resData.data.code
      quoteRequestChange([resData.data])
    }
  }
}

const getLastGasoline = async () => {
  if (!dataAdd.value.oilPrice) {
    const api = $url.cost.gasoline.getGasolineLast
    const res = await $api(api)
    const resData: any = res?.data.value
    if (resData?.success) {
      if (resData.data) {
        dataAdd.value.oilPrice = resData?.data?.amount || 0
      }
    }
  }
}

const closeOverSide = () => {
  resetField()
  visible.value = false
}

const dataAdd = ref<IVendorPrice>($disableReactive(initData))
const popover = ref()
const priceOfflineFee = ref<any[]>([])

defineExpose({ open })

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }

  return 'grid-cols-1'
})

const resetField = () => {
  dataAdd.value = $disableReactive(initData)
  minWeightCommodity.value = -1
  priceOfflineFee.value = []
  dataWorkflow.value.positions = []
}

const vendorChange = (values: any) => {
  dataAdd.value.contact = null
  dataAdd.value.contactName = ''
  dataAdd.value.email = ''
  dataAdd.value.phone = ''
}

const selectContact = (contact: any) => {
  if (Array.isArray(contact) && contact.length) {
    dataAdd.value.contactName = contact[0]?.fullName || ''
    dataAdd.value.email = contact[0]?.email || ''
    dataAdd.value.phone = contact[0]?.phone || ''
    return
  }
  dataAdd.value.contactName = contact?.fullName || ''
  dataAdd.value.email = contact?.email || ''
  dataAdd.value.phone = contact?.phone || ''
}

const dataWorkflow = shallowRef<{ [key: string]: any }>({})

const selectWorkflow = (workflow: any) => {
  if (Array.isArray(workflow) && workflow.length) {
    // Use shallowRef to prevent deep reactivity that might cause recursive updates
    dataWorkflow.value = workflow[0]
  } else {
    dataWorkflow.value = {}
  }
  setDataHandleSelectWorkflow()
}

const setDataHandleSelectWorkflow = () => {
  dataAdd.value.positions = dataWorkflow.value.positions || []
  dataAdd.value.transportation = dataWorkflow.value.transportation || ''
  dataAdd.value.theSamePositions = dataWorkflow.value.theSamePositions || ''
  dataAdd.value.vehicleCategory = null
  dataAdd.value.vehicleCategoryName = ''
  dataAdd.value.contCategory = null
  dataAdd.value.tasks = [
    {
      code: '',
      value: ''
    }
  ]
  setDataPosition()
}

const setDataPosition = () => {
  dataAdd.value.positions.forEach((position: { [key: string]: any }, index: number) => {
    if (['Cảng', 'DEPOT', 'ICD'].includes(position.nodeTypeName)) {
      dataAdd.value.positions[index].quoteEqual = 'NODE'
    } else {
      dataAdd.value.positions[index].quoteEqual = 'WARD'
    }
  })
}

const loadingSelectNode = ref(false)

const handelChangeSelectNode = async (indexRoute: number, val: Array<{ [key: string]: any }>) => {
  loadingSelectNode.value = true
  try {
    const nodeTheSame: Array<number> | undefined = getNodeTheSamePosition(indexRoute, $disableReactive(dataAdd.value.theSamePositions))
    if (Array.isArray(val) && val.length && typeof val[0].location === 'string') {
      let dataPosition: { [key: string]: any } = {}
      const api = $urlAdmin.node.location.detail
      const res = await $api(api, { uriParams: { ID: val[0].location } })
      const resData: any = res?.data?.value
      if (resData?.success) {
        dataPosition = resData.data
      }

      if (dataPosition) {
        // Create a copy of positions to avoid direct mutation during updates
        const updatedPositions = [...dataAdd.value.positions]

        updatedPositions[indexRoute].lat = val[0]?.locationData?.[0]?.lat || dataPosition.lat
        updatedPositions[indexRoute].lng = val[0]?.locationData?.[0]?.lng || dataPosition.lng

        if (Array.isArray(nodeTheSame)) {
          nodeTheSame.forEach((numberRoute: number) => {
            if (numberRoute !== indexRoute) {
              if (Array.isArray(dataPosition.nodeDetail) && dataPosition.nodeDetail.length) {
                let findItemPosition = dataPosition.nodeDetail.find((itemNode: { [key: string]: any }) => {
                  return itemNode.nodeType && itemNode.nodeType.name === updatedPositions[numberRoute].nodeTypeName
                })
                const businessAndTask = checkBusinessAndTask(findItemPosition, updatedPositions[numberRoute])
                if (businessAndTask) {
                  findItemPosition = undefined
                }
                updatedPositions[numberRoute].node = findItemPosition?._id || ''
                updatedPositions[numberRoute].fullNameNode = findItemPosition?.fullNameNode || ''
                updatedPositions[numberRoute].lat = val[0]?.locationData?.[0]?.lat || dataPosition.lat
                updatedPositions[numberRoute].lng = val[0]?.locationData?.[0]?.lng || dataPosition.lng
              }
            }
          })
        }

        // Update the positions array once with all changes
        dataAdd.value.positions = updatedPositions
      }
    } else {
      // Create a copy of positions to avoid direct mutation during updates
      const updatedPositions = [...dataAdd.value.positions]

      updatedPositions[indexRoute].lat = ''
      updatedPositions[indexRoute].lng = ''

      if (nodeTheSame) {
        nodeTheSame.forEach((numberRoute: number) => {
          if (numberRoute !== indexRoute) {
            updatedPositions[numberRoute].node = ''
            updatedPositions[numberRoute].fullNameNode = ''
            updatedPositions[numberRoute].lat = ''
            updatedPositions[numberRoute].lng = ''
          }
        })
      }

      // Update the positions array once with all changes
      dataAdd.value.positions = updatedPositions
    }
  } finally {
    loadingSelectNode.value = false
  }
}

const getNodeTheSamePosition = (index: number, data: Array<Array<number>>) => {
  if (typeof index !== 'number' || !Array.isArray(data)) {
    return
  }
  let result: Array<number> = []
  const filteredItems = data.filter((i: Array<number>) => i.includes(index))
  const tempData = data.filter((i: Array<number>) => !i.includes(index))
  filteredItems.forEach((item) => {
    if (!Array.isArray(item) || item.length !== 2) {
      return
    }
    const tempIndex = item.findIndex((o) => o === index)
    let tempIndex2
    if (tempIndex === 0) {
      tempIndex2 = 1
    } else {
      tempIndex2 = 0
    }

    result.push(item[1])
    result.push(item[0])

    const itemNodeTheSames: Array<number> | undefined = getNodeTheSamePosition(item[tempIndex2], tempData)
    if (Array.isArray(itemNodeTheSames)) {
      result = result.concat(itemNodeTheSames)
    }
  })
  return $lodash.uniq(result)
}

const handleSubmit = $lodash.debounce(() => {
  const api = $urlPartner.sellingPrice.add

  $api(api, { body: { ...dataAdd.value, minWeightCommodity: minWeightCommodity.value } }).then((data) => {
    const resData: any = data?.data?.value

    if (resData?.success) {
      resetField()
      process.client && $toast().success($t('labels.addSuccess'))
      closeOverSide()
      emits('refreshTables')
    }
  })
}, 300)

const taskData: { [key: string]: any } = computed(() => {
  return store.data.getTasks
})

const configCont: { [key: string]: any } = computed(() => store.globalSettings.getGlobalSettings.configCont)
const configVehicle: { [key: string]: any } = computed(() => {
  return store.data.getVehicleCategories
})

const CRules = computed(() => {
  const rules: { [key: string]: any } = { ...ruleAddVendorPrices }
  delete rules.vendor

  if (dataAdd.value.effectiveFromDate) {
    const date = dataAdd.value.effectiveFromDate ? new Date(dataAdd.value.effectiveFromDate) : ''
    if (date && dataAdd.value.effectiveToDate) {
      date.setDate(date.getDate() + 1)
      rules['vendorPriceModule.effectiveToDate'] = rules['vendorPriceModule.effectiveToDate'] + `|min_date:${date.toISOString().split('T')[0]}`
    }
  }
  dataAdd.value.tasks.forEach((task, index) => {
    const dataTask: { [key: string]: any } = taskData.value.find((iTask: { [key: string]: any }) => iTask._id === task.task)
    if (dataTask && dataTask.completionTimes) {
      const keyCompletionTime = dataAdd.value.transportation === 'CONTAINER' ? 'contCategory' : 'vehicleCategory'
      const minimumTime =
        dataTask.completionTimes &&
        dataTask.completionTimes[keyCompletionTime][dataAdd.value[keyCompletionTime] || ''] &&
        dataTask.completionTimes[keyCompletionTime][dataAdd.value[keyCompletionTime] || ''].minimumTime
          ? dataTask.completionTimes[keyCompletionTime][dataAdd.value[keyCompletionTime] || ''].minimumTime
          : 0
      if (dataAdd.value.createPriceFrom === 3) {
        rules['time' + index] = `min_value:${minimumTime}`
      } else {
        rules['time' + index] = `validationCustom:
        ${task.minimumTime <= task.value}--
        Thời gian hoàn thành tối đa của tác vụ phải lớn hơn hoặc bằng thời gian hoàn thành được yêu cầu từ yêu cầu báo giá (${task.minimumTime} giờ)`
      }
    }
  })
  if (dataAdd.value.transportation === 'CONTAINER' && dataAdd.value.contCategory) {
    if (configCont.value && configCont.value[dataAdd.value.contCategory] && configCont.value[dataAdd.value.contCategory].weightCargo) {
      const formatWeightCargo = $formatters.formatCurrency(configCont.value[dataAdd.value.contCategory].weightCargo).replaceAll(',', 'LA==')
      if (minWeightCommodity.value < 0 && (dataAdd.value.weightCommodity || 0) >= configCont.value[dataAdd.value.contCategory].weightCargo) {
        rules.weightCommodityByKGMaximum = `required|validationCustom:
        ${dataAdd.value.weightCommodity && dataAdd.value.weightCommodity <= configCont.value[dataAdd.value.contCategory].weightCargo}--
        ${$t('labels.checkWeightContainer')} - ${configCont.value[dataAdd.value.contCategory].weightCargo}`
      } else {
        rules.weightCommodityByKGMaximum = `required|validationCustom:
        ${
          dataAdd.value.weightCommodity &&
          dataAdd.value.weightCommodity >= minWeightCommodity.value &&
          dataAdd.value.weightCommodity <= configCont.value[dataAdd.value.contCategory].weightCargo
        }
        --${$t('labels.checkWeightVehicle2')} (${minWeightCommodity.value} kg)
        và nhỏ hơn trọng lượng hàng tối đa được cài đặt cho loại contaier ${listLabelCont[Number(dataAdd.value.contCategory)]} - ${formatWeightCargo} kg.`
      }
    }
  } else if (dataAdd.value.transportation === 'NON_CONTAINER' && dataAdd.value.vehicleCategory && configVehicle.value) {
    const findVehicleCategory = configVehicle.value.find((findVehicleCategory: { [key: string]: any }) => {
      return findVehicleCategory._id === dataAdd.value.vehicleCategory
    })
    if (findVehicleCategory) {
      const min = Number(findVehicleCategory.from || 0)
      const max = Number(findVehicleCategory.to || 999999999999999)
      const formatMax = $formatters.formatCurrency(max).replaceAll(',', 'LA==')
      if (minWeightCommodity.value < 0) {
        rules.weightCommodityByKGMaximum = `required|validationCustom:
        ${dataAdd.value.weightCommodity && min <= dataAdd.value.weightCommodity && dataAdd.value.weightCommodity < max}--
        ${$t('labels.checkWeightVehicle')} (${min} <= ${$t('labels.weightCommodity')} < ${max})`
      } else {
        rules.weightCommodityByKGMaximum =
          `required|validationCustom:
        ${dataAdd.value.weightCommodity && dataAdd.value.weightCommodity >= minWeightCommodity.value && dataAdd.value.weightCommodity < max}` +
          `--${$t('labels.checkWeightVehicle2')}(${minWeightCommodity.value} kg) và nhỏ hơn trọng tải tối đa của loại xe` +
          ` ${findVehicleCategory.name || ''} - ${formatMax} kg`
      }
    }
  }
  return rules
})

const listSelectQuoteEqual = [
  {
    value: 'NODE',
    label: $t('labels.node')
  },
  {
    value: 'WARD',
    label: $t('labels.ward')
  },
  {
    value: 'DISTRICT',
    label: $t('labels.district')
  },
  {
    value: 'CITY',
    label: $t('labels.city')
  }
]
const dataSelectWorkFlowData = [
  {
    value: 20,
    label: $t('labels.vehicleModule.20ft')
  },
  {
    value: 40,
    label: $t('labels.vehicleModule.40ft')
  },
  {
    value: 45,
    label: $t('labels.vehicleModule.45ft')
  }
]

const taskItems = computed(() => {
  const result: Array<{ [key: string]: any }> = []
  if (Array.isArray(dataWorkflow.value.positions)) {
    dataWorkflow.value.positions.forEach((positions: { [key: string]: any }) => {
      if (Array.isArray(positions.tasks)) {
        positions.tasks.forEach((task: { [key: string]: any }) => {
          const index = result.findIndex((i) => i.key === task.key)
          if (index === -1 && task.responsibleForImplementation === 'CUSTOMER') {
            task.index = positions.index || ''
            task.nodeType = positions.nodeType || ''
            task.node = positions.node || ''
            task._id = positions._id || ''
            task.nodeTypeName = positions.nodeTypeName || ''
            task.code = (positions.nodeType || '') + '-' + task.key
            const findIndexSelected = dataAdd.value.tasks.findIndex((iTask) => iTask.code === task.code)
            task.disabled = false
            if (findIndexSelected !== -1) {
              task.disabled = true
            }
            result.push(task)
          }
        })
      }
    })
  }
  return result
})

const handleChangeSelectedTask = (data: any, index: number) => {
  if (Array.isArray(data) && data.length) {
    if (dataAdd.value.createPriceFrom === 2 || dataAdd.value.createPriceFrom === 1) {
      const indexData = dataAdd.value.tasks.findIndex((task: { [key: string]: any }) => {
        return task.code === data[0].code
      })
      if (indexData !== -1) {
        dataAdd.value.tasks[indexData] = { ...dataAdd.value.tasks[indexData], ...data[0] }
        const dataPosition = dataWorkflow.value.positions.find((position: { [key: string]: any }) => {
          return data[0]._id === position._id && data[0].nodeType === position.nodeType && data[0].node === position.node
        })
        if (dataPosition) {
          const dataTask = dataPosition.tasks.find((task: { [key: string]: any }) => {
            return task.business === data[0].business && task.task === data[0].task
          })
          if (dataTask) {
            dataAdd.value.tasks[indexData].value = dataTask.timeComplete
            dataAdd.value.tasks[indexData].minimumTime = dataTask.timeComplete
          }
        }
      }
    } else {
      const indexData = dataAdd.value.tasks.findIndex((task: { [key: string]: any }) => {
        return task.code === data[0].code
      })

      if (indexData !== -1) {
        dataAdd.value.tasks[indexData] = { ...dataAdd.value.tasks[indexData], ...data[0] }
        const dataTask: { [key: string]: any } = taskData.value.find((iTask: { [key: string]: any }) => iTask._id === dataAdd.value.tasks[indexData].task)

        if (dataTask && dataTask.completionTimes) {
          const keyCompletionTime = dataAdd.value.transportation === 'CONTAINER' ? 'contCategory' : 'vehicleCategory'

          const value =
            dataTask.completionTimes &&
            dataTask.completionTimes[keyCompletionTime][dataAdd.value[keyCompletionTime] || ''] &&
            dataTask.completionTimes[keyCompletionTime][dataAdd.value[keyCompletionTime] || ''].averageTime
              ? dataTask.completionTimes[keyCompletionTime][dataAdd.value[keyCompletionTime] || ''].averageTime
              : ''

          dataAdd.value.tasks[indexData].value = value
          dataAdd.value.tasks[indexData].minimumTime = value
        }
      }
    }
  } else {
    dataAdd.value.tasks[index].value = ''
    dataAdd.value.tasks[index].minimumTime = ''
  }
}

const addTask = () => {
  dataAdd.value.tasks.push({
    code: '',
    value: null
  })
}

const cTypeCommodity = computed(() => {
  const result: Array<{ [key: string]: any }> = $disableReactive(typeCommodity)
  if (dataAdd.value.typeCommodity && dataAdd.value.typeCommodity.length === 1 && dataAdd.value.typeCommodity.includes('NORMAL')) {
    result.forEach((i: { [key: string]: any }, index: number) => {
      if (i.key !== 'NORMAL') {
        result[index].disabled = true
      }
    })
  } else if (dataAdd.value.typeCommodity && dataAdd.value.typeCommodity.length && !dataAdd.value.typeCommodity.includes('NORMAL')) {
    result[0].disabled = true
  }
  return result
})

const typeCommodity = [
  {
    key: 'NORMAL',
    title: $t('labels.ordinaryGoods')
  },
  // {
  //   key: 'LIQUID',
  //   title: $t('labels.liquid')
  // },
  // {
  //   key: 'GAS',
  //   title: $t('labels.gas')
  // },  ko xoá cmt
  {
    key: 'FROZEN',
    title: $t('labels.frozen')
  },
  {
    key: 'DANGEROUS',
    title: $t('labels.dangerousGoods')
  },
  {
    key: 'FRAGILE',
    title: $t('labels.fragileGoods')
  }
  // {
  //   key: 'OVERWEIGHT',
  //   title: $t('labels.overweightCargo')
  // } ko xoá cmt
]

const handleApplyPositionMap = (positions: Array<{ [key: string]: any }>) => {
  dataAdd.value.positions = $disableReactive(positions)
}
const mapPosition = ref()

const openWithMap = () => {
  mapPosition.value && mapPosition.value.open($disableReactive(dataAdd.value.positions), $disableReactive(dataAdd.value.theSamePositions))
}
const getKeySubLabel = (locationType: string) => {
  if (locationType === 'NODE') {
    return 'address'
  }
  return 'address'
}
const getKeyLabel = (locationType: string) => {
  if (locationType === 'NODE') {
    return 'name'
  }
  return 'addressByType'
}
const handleChangeSelectedQuoteEqual = (index: number) => {
  dataAdd.value.priceOfflineFee = []
  const position = dataAdd.value.positions[index]

  if (dataAdd.value.createPriceFrom === 3) {
    position.node = ''
    position.fullNameNode = ''
    return
  }

  let keyAddress = ''

  switch (position.quoteEqual) {
  case 'NODE':
    keyAddress = 'address'
    break
  case 'WARD':
    keyAddress = 'areaLevel3'
    break
  case 'DISTRICT':
    keyAddress = 'areaLevel2'
    break
  case 'CITY':
    keyAddress = 'areaLevel1'
    break
  }

  if (!keyAddress) {
    position.node = ''
    position.fullNameNode = ''
    return
  }

  const nodeData = position.nodeData
  const fullNameNode = keyAddress === 'address' ? (position.fullNameNode = position.nodeName) : nodeData.addressDetail?.[keyAddress]?.formatted_address || ''

  if (!fullNameNode) {
    position.node = ''
    position.fullNameNode = ''
    return
  }

  position.fullNameNode = fullNameNode
}

const deleteTask = (index: number) => {
  dataAdd.value.tasks.splice(index, 1)
}

const changeCategoryShipping = () => {
  if (!dataAdd.value.weightCommodity) {
    if (dataAdd.value.transportation === 'CONTAINER' && dataAdd.value.contCategory) {
      if (configCont.value && configCont.value[dataAdd.value.contCategory] && configCont.value[dataAdd.value.contCategory].weightCargo) {
        dataAdd.value.weightCommodity = configCont.value[dataAdd.value.contCategory].weightCargo
      }
    }
  }
}

const checkBusinessAndTask = (node: { businesses: { [key: string]: Array<string> } }, route: { [key: string]: any }): boolean => {
  if (!route.businesses || !Object.keys(route.businesses).length) {
    return false
  }
  return Object.keys(route.businesses).some((item: string) => {
    if (!node || !node.businesses || !Object.keys(node.businesses).length || !node?.businesses[item]) {
      return true
    }
    return route.businesses[item].some((task: string) => {
      return !node?.businesses[item].includes(task)
    })
  })
}

const createPriceFromChange = (value: number) => {
  if (passCreateFromChange.value) {
    return
  }
  resetField()
  dataAdd.value.createPriceFrom = value
}

const quoteChange = (values: any) => {
  const quoteData = values?.[0] || ({} as any)
  dataAdd.value.workflow = quoteData.workflow || ''
  dataAdd.value.workflowName = quoteData.workflowName || ''
  dataAdd.value.positions = quoteData.positions || []
  dataAdd.value.transportation = quoteData.transportation || ''
  dataAdd.value.mergeContainer = quoteData.mergeContainer || false
  dataAdd.value.headContainer = quoteData.headContainer || false
  dataAdd.value.vehicleCategory = quoteData.vehicleCategory || ''
  dataAdd.value.vehicleCategoryName = quoteData.vehicleCategoryName || ''
  dataAdd.value.contCategory = quoteData.contCategory || null
  dataAdd.value.typeCommodity = getTypeCommodity(quoteData) || []
  dataAdd.value.weightCommodity = quoteData.weightCommodity || null
  dataAdd.value.tasks = [
    {
      code: '',
      value: null
    }
  ]
  minWeightCommodity.value = quoteData.weightCommodity || -1
  priceOfflineFee.value = quoteData.priceOfflineFee || []
  dataWorkflow.value.positions = quoteData.positions || []
}

const quoteRequestChange = (values: any) => {
  const quoteRequestData = values?.[0] || ({} as any)
  dataAdd.value.workflow = quoteRequestData.workflow || ''
  dataAdd.value.workflowName = quoteRequestData.workflowName || ''
  dataAdd.value.positions = quoteRequestData.positions || []
  dataAdd.value.transportation = quoteRequestData.transportation || ''
  dataAdd.value.mergeContainer = quoteRequestData.mergeContainer || false
  dataAdd.value.headContainer = quoteRequestData.headContainer || false
  dataAdd.value.vehicleCategory = quoteRequestData.vehicleCategory || ''
  dataAdd.value.vehicleCategoryName = quoteRequestData.vehicleCategoryName || ''
  dataAdd.value.contCategory = quoteRequestData.contCategory || null
  dataAdd.value.typeCommodity = getTypeCommodity(quoteRequestData) || []
  dataAdd.value.weightCommodity = quoteRequestData.weightCommodity || null
  minWeightCommodity.value = quoteRequestData.weightCommodity || -1
  dataWorkflow.value.positions = quoteRequestData.positions || []
  dataAdd.value.tasks = [
    {
      code: '',
      value: null
    }
  ]
}

const disabled = computed(() => {
  if (dataAdd.value.createPriceFrom === 3) {
    return false
  }

  return true
})

const priceOfflineFeeChange = (item: any) => {
  dataAdd.value.priceOfflineFee = item || []
}

const { $formatters } = useNuxtApp()

const headers = [
  {
    headerName: $t('labels.action'),
    key: 'selection',
    suppressMenu: true,
    checkboxSelection: true,
    width: 100,
    maxWidth: 100
  },
  {
    field: 'positions',
    headerName: $t('labels.route'),
    sortable: true,
    valueGetter: (params: any) => {
      const pluckData = $lodash.map(params.data?.positions, 'fullNameNode')
      return $lodash.join(pluckData, ' >> ')
    }
  },
  {
    field: 'pricingEstimate.totalOfflineFee',
    headerName: $t('labels.priceOfflineFee'),
    sortable: true,
    valueGetter: (params: any) => {
      return $formatters.formatCurrency(params.data.pricingEstimate.totalOfflineFee || 0)
    }
  }
]

const CQuoteByNode = computed(() => {
  const positions: any = dataAdd.value?.positions || []
  const results = positions.map((item: any) => item.quoteEqual === 'NODE')
  return !results.includes(false)
})

const listLabelCont: { [key: number]: any } = {
  10: $t('labels.vehicleModule.10ft'),
  20: $t('labels.vehicleModule.20ft'),
  40: $t('labels.vehicleModule.40ft'),
  45: $t('labels.vehicleModule.45ft'),
  50: $t('labels.vehicleModule.other')
}
</script>
